import api from './api';

export interface Location {
  id: string;
  name: string;
  address?: string;
  whatsappNumber?: string;
  currency?: string; // ISO code, e.g. 'SGD' / 'IDR'
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  dressCount?: number;
}

export interface CreateLocationRequest {
  name: string;
  address?: string;
  whatsappNumber?: string;
  currency?: string;
}

export const locationService = {
  // Get all locations
  async getLocations(): Promise<Location[]> {
    const response = await api.get('/locations');
    return response.data.data;
  },

  // Get single location
  async getLocation(id: string): Promise<Location> {
    const response = await api.get(`/locations/${id}`);
    return response.data.data;
  },

  // Create location
  async createLocation(location: CreateLocationRequest): Promise<Location> {
    const response = await api.post('/locations', location);
    return response.data.data;
  },

  // Update location
  async updateLocation(id: string, updates: Partial<Omit<CreateLocationRequest, 'id'>> & { isActive?: boolean }): Promise<Location> {
    const response = await api.put(`/locations/${id}`, updates);
    return response.data.data;
  },

  // Delete location
  async deleteLocation(id: string): Promise<void> {
    await api.delete(`/locations/${id}`);
  },
};